export const learnMoreLink =
    'https://support.approvalmax.com/portal/en/kb/articles/how-do-i-set-up-the-pull-from-xero-step-for-sales-invoice';
